import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-botanical-dark text-cream py-12 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          
          <div className="col-span-1 md:col-span-1">
             <Link to="/" className="flex items-center gap-2 mb-4">
              <SafeIcon icon={FiIcons.FiFeather} className="text-2xl text-clay" />
              <span className="font-serif text-2xl font-semibold">RootRoom</span>
            </Link>
            <p className="text-sm text-cream/70 mb-4">
              Cultivating serene spaces with healthy, happy houseplants. Your journey to a greener home starts here.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-cream/70 hover:text-clay transition-colors">
                <SafeIcon icon={FiIcons.FiInstagram} className="text-xl" />
              </a>
              <a href="#" className="text-cream/70 hover:text-clay transition-colors">
                <SafeIcon icon={FiIcons.FiTwitter} className="text-xl" />
              </a>
              <a href="#" className="text-cream/70 hover:text-clay transition-colors">
                <SafeIcon icon={FiIcons.FiFacebook} className="text-xl" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-serif text-lg mb-4 text-clay-light">Shop</h3>
            <ul className="space-y-2 text-sm text-cream/70">
              <li><Link to="/shop" className="hover:text-cream transition-colors">All Plants</Link></li>
              <li><Link to="/shop" className="hover:text-cream transition-colors">Beginner Bundles</Link></li>
              <li><Link to="/shop" className="hover:text-cream transition-colors">Accessories</Link></li>
              <li><Link to="/shop" className="hover:text-cream transition-colors">Gift Cards</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-serif text-lg mb-4 text-clay-light">Support</h3>
            <ul className="space-y-2 text-sm text-cream/70">
              <li><Link to="/faq" className="hover:text-cream transition-colors">FAQ & Care</Link></li>
              <li><Link to="/faq" className="hover:text-cream transition-colors">Shipping & Returns</Link></li>
              <li><Link to="/dashboard" className="hover:text-cream transition-colors">Plant Dashboard</Link></li>
              <li><a href="#" className="hover:text-cream transition-colors">Contact Us</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-serif text-lg mb-4 text-clay-light">Join the Nursery</h3>
            <p className="text-sm text-cream/70 mb-4">Get 10% off your first order and weekly plant care tips.</p>
            <form className="flex">
              <input 
                type="email" 
                placeholder="Email address" 
                className="bg-botanical px-4 py-2 rounded-l-md focus:outline-none focus:ring-1 focus:ring-clay text-cream placeholder-cream/50 w-full"
              />
              <button type="submit" className="bg-clay hover:bg-clay-dark px-4 py-2 rounded-r-md transition-colors text-white">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-botanical/50 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-cream/50">
          <p>&copy; {new Date().getFullYear()} RootRoom Plants. All rights reserved.</p>
          <p className="mt-4 md:mt-0 font-medium tracking-wide">Made by LingLink AI and DigLab AI</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;